import React from "react";
import { Box, Typography } from '@curves/ui-base';

import clsx from "clsx";
const TimelineRecordItem = ({ className, metainfo = [], children }) => {
	return (
		<Box className={clsx("timeline-record-item", className, "time-line-item")}>
			<Box className="timeline-record-item__meta">
				{metainfo.map((item, idx) => (
					<Box key={idx} className="timeline-record-item__meta-row">
						<Typography component="span" className="label font-color-3">{item?.label}</Typography>
						<Typography component="span" className="text">{item?.text}</Typography>
					</Box>
				))}
			</Box>
			<Box className="timeline-record-item__card">{children}</Box>
		</Box>
	);
};
export default TimelineRecordItem;
